import qs from 'query-string';
import { useLocation } from 'react-router';

export const useAnchor = () => {
    const { search } = useLocation();
    const params = qs.parse(search);

    return params?.anchor;
};
